import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { PieceButtonRenderComponent } from './piece-button-render.component';


export const pieceButtonRenderModuleEntryComponents = [
  PieceButtonRenderComponent
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule
  ],
  declarations: pieceButtonRenderModuleEntryComponents
})
export class PieceButtonRenderModule {}

export default pieceButtonRenderModuleEntryComponents;
